import * as actionTypes from './actionTypes';

export const setClientId = (value: string) => ({
  type: actionTypes.CLIENT_ID_SET,
  payload: value
});

export const setCurrentBrand = (value: string) => ({
  type: actionTypes.CURRENT_BRAND_SET,
  payload: value
});

export const setEnterpriseBrand = (value: string) => ({
  type: actionTypes.ENTERPRISE_BRAND_SET,
  payload: value
});

export const setIsBrandFilterable = value => ({
  type: actionTypes.IS_BRAND_FILTERABLE_SET,
  payload: value
});

export const setIsWhiteListedForCampaign = value => ({
  type: actionTypes.IS_WHITELISTED_FOR_CAMPAIGNS_SET,
  payload: value
});
